import { graphql } from '@/graphql-setup'
import type { ResultOf } from 'gql.tada'

export const ALL_SALARY_ITEM_GENERATION_MODIFIERS_QUERY = graphql(`
  query AllSalaryItemGenerationModifiers {
    allSalaryItemGenerationModifiers {
      id
      name
      kind
      priority
      isActive
      appliesTo
      salaryWorkTime {
        id
        name
      }
      users {
        id
        fullName
      }
      zones {
        id
        name
      }
      countries {
        id
        name
        isoCode
      }
      restTypes
      matchMode
      locationTest
      minDurationHours
      maxDurationHours
      validFrom
      validTo
      award
      amount
      perDurationHours
      rounding
      maxAmount
      salaryCode {
        id
        name
      }
      chainAction
    }
  }
`)

export const SALARY_ITEM_GENERATION_AREAS_QUERY = graphql(`
  query SalaryItemGenerationAreas {
    salaryItemGenerationZones {
      id
      name
    }
    salaryItemGenerationCountries {
      id
      name
      isoCode
    }
  }
`)

export type GenerationModifierNode = ResultOf<
  typeof ALL_SALARY_ITEM_GENERATION_MODIFIERS_QUERY
>['allSalaryItemGenerationModifiers'][number]

export const DIET_SETTINGS_SALARY_WORK_TIMES_QUERY = graphql(`
  query DietSettingsSalaryWorkTimes {
    allSalaryWorkTimes {
      id
      name
      salaryType
      useAutomaticDietGeneration
      useAutomaticSalaryDayGeneration
      useAdvancedCalculation
      useSixHourRuleForCalculation
      user {
        id
        fullName
      }
      generationRules {
        id
        kind
        rule
        restHandling
        amount
        perDurationHours
        rounding
        isActive
        dietSalaryCode {
          id
          name
        }
        salaryDaySalaryCode {
          id
          name
        }
      }
    }
  }
`)

export type DietSettingsSalaryWorkTime = ResultOf<
  typeof DIET_SETTINGS_SALARY_WORK_TIMES_QUERY
>['allSalaryWorkTimes'][number]

export type GenerationRuleNode =
  DietSettingsSalaryWorkTime['generationRules'][number]
